import ReplayIcon from '@mui/icons-material/Replay';
import { Button, CircularProgress } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

type HilSegmentsRetryAllToolbarButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export default function HilSegmentsRetryAllToolbarButton({
  onClick,
  disabled = false,
  loading = false,
}: HilSegmentsRetryAllToolbarButtonProps) {
  const theme = useTheme();

  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={
        loading ? <CircularProgress size={18} /> : <ReplayIcon fontSize="small" />
      }
      variant="text"
      size="small"
      aria-label="Retry all segments shown in the current grid"
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        color: 'primary.main',
        borderRadius: '4px',
        padding: '6px 8px',
        fontSize: '0.875rem',
        minWidth: 'auto',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          transform: 'scale(1.02)',
        },
        '&:disabled': {
          color: theme.palette.action.disabled,
          transform: 'none',
        },
      }}
    >
      Retry All
    </Button>
  );
}
